import { ResetForm } from "@/components/auth/reset-form.tsx";
import { m } from "@/paraglide/messages.js";
import { organizationsQueryOptions } from "@/services/organization-service.ts";
import { EMAIL_TOKEN_REGEX } from "@/utils/validation.ts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

// Setup token validation - should be base64 encoded string
const resetRouteSchema = z.object({
	email: z.email(),
	token: z.string().regex(EMAIL_TOKEN_REGEX),
});

export const Route = createFileRoute("/auth/reset")({
	component: ResetComponent,
	validateSearch: resetRouteSchema,
	beforeLoad: ({ search }) => {
		const result = resetRouteSchema.safeParse(search);
		if (!result.success) {
			throw redirect({
				to: "/auth/login",
				replace: true,
			});
		}
	},
	loaderDeps: ({ search: { token } }) => ({ token }),
	loader: async ({ context: { queryClient }, deps: { token } }) => {
		const [orgs] = await Promise.all([
			queryClient.ensureQueryData(organizationsQueryOptions(token)),
		]);

		if (orgs.length === 0) {
			throw redirect({
				to: "/auth/login",
				replace: true,
			});
		}

		return { orgs };
	},
	head: () => ({
		meta: [{ title: pageTitle(m.auth_reset_title()) }],
	}),
});

function ResetComponent() {
	return <ResetForm />;
}
